import { ApiError } from "@/shared/api/http-client";
import { resolveMutationErrorMessage } from "@/shared/api/error-message";

const RATE_LIMITED_STATUS = 429;

/**
 * User-facing copy for a failed "send password reset" mutation.
 *
 * `POST /api/auth/password-reset/send` always answers 200 (no account
 * enumeration), so the only expected 4xx is the throttler's 429 — mapped
 * to a dedicated message rather than the raw `ThrottlerException` text.
 * Everything else follows the shared BO precedence rules.
 */
export function resolvePasswordResetErrorMessage(
  err: unknown,
  t: (key: string, values?: Record<string, unknown>) => string,
): string {
  if (err instanceof ApiError && err.status === RATE_LIMITED_STATUS) {
    return t("users.passwordReset.rateLimit");
  }
  return resolveMutationErrorMessage(err, t, {
    forbiddenKey: "users.errors.forbidden",
    serverPrefixKey: "users.errors.serverPrefix",
    genericKey: "users.passwordReset.error",
  });
}
